// extracted by mini-css-extract-plugin
module.exports = {"table":"OrderSummaryCard_table_1bdHB","amount":"OrderSummaryCard_amount_2ifG0"};